import React, { useMemo, useState } from "react";

const API_ROOT = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

const STATUS_OPTIONS = [
  { value: "AL", label: "All" },
  { value: "NE", label: "New" },
  { value: "IP", label: "In Process" },
  { value: "IT", label: "In Process & Transfer" },
  { value: "CT", label: "Close & Transfer" },
  { value: "CL", label: "Closed" },
];

export default function ResolverComplaintList() {
  const localUser = useMemo(() => {
    try { return JSON.parse(localStorage.getItem("user") || "null"); }
    catch { return null; }
  }, []);

  const moduleId = parseInt(localUser?.moduleId, 10);
  const empId    = parseInt(localUser?.id,       10);

  const [filter, setFilter] = useState({
    status:          "AL",
    fromDate:        "",
    toDate:          "",
    fromComplaintId: "",
    toComplaintId:   "",
  });
  const [complaints, setComplaints] = useState(null);
  const [loading,    setLoading]    = useState(false);
  const [error,      setError]      = useState("");

  const onChange = (e) => {
    const { name, value } = e.target;
    setFilter(prev => ({ ...prev, [name]: value }));
  };

  const onView = async (e) => {
    e.preventDefault();
    setError(""); setComplaints(null); setLoading(true);
    try {
      const params = new URLSearchParams({ moduleId, empId, status: filter.status });
      if (filter.fromDate)        params.append("fromDate",        filter.fromDate);
      if (filter.toDate)          params.append("toDate",          filter.toDate);
      if (filter.fromComplaintId) params.append("fromComplaintId", filter.fromComplaintId);
      if (filter.toComplaintId)   params.append("toComplaintId",   filter.toComplaintId);

      const res  = await fetch(`${API_ROOT}/api/complaints/resolver-list?${params}`);
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to load complaints.");
      setComplaints(data.data || []);
    } catch (err) {
      setError(err.message || "Failed to load complaints.");
    } finally {
      setLoading(false);
    }
  };

  if (moduleId !== 9) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">Unauthorized access Or Session Timed out.</div>
      </div>
    );
  }

  return (
    <div className="container-fluid mt-3">
      <h3 className="ctitle">Complaint Report</h3>

      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={onView}>
        <div className="row g-2 align-items-end mb-3">

          <div className="col-sm-2">
            <label className="form-label mb-1">Status</label>
            <select
              className="form-select"
              name="status"
              value={filter.status}
              onChange={onChange}
            >
              {STATUS_OPTIONS.map(o => (
                <option key={o.value} value={o.value}>{o.label}</option>
              ))}
            </select>
          </div>

          <div className="col-sm-2">
            <label className="form-label mb-1">From Date</label>
            <input
              className="form-control"
              type="date"
              name="fromDate"
              value={filter.fromDate}
              onChange={onChange}
            />
          </div>

          <div className="col-sm-2">
            <label className="form-label mb-1">To Date</label>
            <input
              className="form-control"
              type="date"
              name="toDate"
              value={filter.toDate}
              onChange={onChange}
            />
          </div>

          <div className="col-sm-2">
            <label className="form-label mb-1">From ComplaintID</label>
            <input
              className="form-control"
              type="text"
              name="fromComplaintId"
              value={filter.fromComplaintId}
              onChange={onChange}
            />
          </div>

          <div className="col-sm-2">
            <label className="form-label mb-1">To ComplaintID</label>
            <input
              className="form-control"
              type="text"
              name="toComplaintId"
              value={filter.toComplaintId}
              onChange={onChange}
            />
          </div>

          <div className="col-sm-2">
            <label className="form-label mb-1">&nbsp;</label>
            <button type="submit" className="btn btn-primary form-control" disabled={loading}>
              {loading ? "Loading..." : "View"}
            </button>
          </div>

        </div>
      </form>

      {complaints !== null && (
        complaints.length === 0 ? (
          <p>No records found.</p>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered table-striped table-sm" style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
              <thead style={{ '--bs-table-bg': '#008080', color: 'white' }}>
                <tr>
                  <th>SNo</th>
                  <th>ComplaintType</th>
                  <th>ComplaintDescription</th>
                  <th>Remarks</th>
                  <th>ComplaintDate</th>
                  <th>Area Type</th>
                  <th>HNo/Dept</th>
                  <th>ComplaintBy</th>
                  <th>Status</th>
                  <th>ComplaintID</th>
                </tr>
              </thead>
              <tbody>
                {complaints.map((c, idx) => (
                  <tr key={`${c.TicketID}-${idx}`}>
                    <td>{idx + 1}</td>
                    <td>{c.ComplaintCategory}</td>
                    <td style={{ whiteSpace: "normal", minWidth: 160 }}>{c.ComplaintDescription}</td>
                    <td style={{ whiteSpace: "normal", minWidth: 140 }}>{c.Remark}</td>
                    <td>{c.DOWPLabel}</td>
                    <td>{c.ResiType}</td>
                    <td>{c.ResidenceID}</td>
                    <td>{c.EmpName}{c.Mobile ? ` - ${c.Mobile}` : ""}</td>
                    <td>{c.StatusLabel}</td>
                    <td>{c.TicketID}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}
    </div>
  );
}
